import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { TenderTypes } from '@web-kc/core/api';
import { useTranslation } from 'next-i18next';
import { LotItem } from '../LotItem';

interface Props {
  data?: TenderTypes['PageContentLotDto'];
  isLoading: boolean;
}

export const LotList = ({ data, isLoading }: Props) => {
  const { t } = useTranslation(['common', 'cabinet']);

  if (isLoading) {
    return <CircularProgress sx={{ padding: '8px' }} />;
  }

  if (!data?.content?.length) {
    return (
      <Stack justifyContent="center" direction="row">
        <Typography variant="body2" fontWeight={700}>
          {t('common:common.notFound')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="column" mt={1.25}>
      {data.content.map((lot, index) => (
        <React.Fragment key={lot.id}>
          <LotItem lot={lot} />
        </React.Fragment>
      ))}
    </Stack>
  );
};
